const FLOW = {
  "PREQUAL": "PREQUAL",
  "DM": "DM",
  "CS": "CS",
  "STANDALONE": "STANDALONE",
  "ACTIVATION_PAYMENT": "ACTIVATION_PAYMENT",
  "PREQUALSTRAIGHT": "PREQUALSTRAIGHT",
  "PREQUALFIT": "PREQUALFIT",
  "CFC": "CFC"
}


const PRODUCT = {
  Grand: { bank: "Grand.bank Plus" },
  Surge: "Surge",
  Reflex: "Reflex",
  Revel: "Revel",
  Fit: "Fit"
}

const BANK = {
  Grand: { bank: "Grand.bank" }
}

const RESULTS = {
  "APPROVED": "APPROVED",
  "PENDFEE": "PENDFEE",
  "PENDUSER": "PENDUSER",
  "DECLINED": "DECLINED",
  "PENDINFO": [
    "FROZEN",
    "FROZENPREQUAL",
    "PENDFEE",
    "PENDFUNDING",
    "PENDINFO",
    "PENDINTERNAL",
  ]
}

export {
  FLOW, PRODUCT, BANK, RESULTS
}; 